import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Environment } from '../../environments/environment';
import { AuthService } from './auth.service';

import * as Sentry from '@sentry/browser';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {

    constructor(
        private authService: AuthService,
        private zone: NgZone,
        private router: Router
    ) { }

    handleError(error) {

        if (!this.isNetworkError(error)) {

            if (Environment.sentryEnable) {

                const eventId = Sentry.captureException(error.originalError || error.error || error);
    
                if (Environment.showSentryDialog) {
    
                    Sentry.showReportDialog({ eventId });
                } 
            }
    
            if (!Environment.production) {
    
                console.error(error.originalError || error.error || error);
                throw error;
            }

        } else {

            this.zone.run(() => this.authService.logout().subscribe(() => this.router.navigate(['/login'])));
        }
    }

    report(error, message = "") {

        if (!this.isNetworkError(error)) {

            if (Environment.sentryEnable) {

                let errorMessage = error.originalError || error.error || error;
            
                if (error.error instanceof ProgressEvent) {

                    errorMessage = error.message;
                }

                const eventId = Sentry.captureException(`${errorMessage} : ${message}`);

                if (Environment.showSentryDialog) {

                    Sentry.showReportDialog({ eventId });
                }
            }

        } else {

            this.zone.run(() => this.authService.logout().subscribe(() => this.router.navigate(['/login'])));
        }
    }

    isNetworkError (errorObject) {

        // Frome Angular Docs: Two types of errors can occur.
        // The server backend might reject the request, returning an HTTP response with a status code such as 404 or 500. These are error responses.
        // Something could go wrong on the client-side such as a network error that prevents the request from completing successfully or an exception thrown in an RxJS operator. 
        // These errors have status set to 0 and the error property contains a ProgressEvent object, whose type might provide further information.
        return errorObject?.status === 0 && errorObject?.error instanceof ProgressEvent;
    }
}
